"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_NEW = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var client_1 = require("@apollo/client");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var SavedPaymentTile_1 = require("../SavedPaymentTile");
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
var icons_1 = require("@alinta-digital/myaccount-frontend-shared/icons");
var SavedPaymentTile_types_1 = require("../SavedPaymentTile/SavedPaymentTile.types");
var SavedPaymentTile_styles_1 = require("../SavedPaymentTile/SavedPaymentTile.styles");
var NewBankIcon_1 = require("../../components/BankDetails/icons/NewBankIcon");
var SavedPaymentTile_loadingState_1 = require("../SavedPaymentTile/SavedPaymentTile.loadingState");
exports.ADD_NEW = 'addNew';
var SavedPaymentTile = function (_a) {
    var radioGroupName = _a.radioGroupName, customerNumber = _a.customerNumber, paymentFilter = _a.paymentFilter, selectedAccountId = _a.selectedAccountId, onChange = _a.onChange, displayHeaderTitle = _a.displayHeaderTitle, setLoading = _a.setLoading, onError = _a.onError;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var _b = (0, react_1.useState)([]), radioBtnProps = _b[0], setRadioBtnProps = _b[1];
    var isBankMode = paymentFilter === SavedPaymentTile_types_1.SavedPaymentType.BANKACCOUNT;
    var addNewRadioBtnData = {
        id: exports.ADD_NEW,
        isMuted: false,
        hasSolidBorder: true,
        isSelected: selectedAccountId === exports.ADD_NEW,
        value: exports.ADD_NEW,
        onChange: function () {
            onChange(exports.ADD_NEW);
        },
        headerNode: (react_1.default.createElement(asg_1.Heading, { level: 5, "data-testid": "addnew", weight: 600, color: asg_1.colors['colour-black'] }, isBankMode ? 'Add new Bank Account' : 'Add new card')),
        descriptionNode: (react_1.default.createElement(asg_1.Text, { color: "#68727C", size: "14px !important", "data-testid": "tileDescription", lineHeight: "20px", weight: 400 }, isBankMode ? 'Add an Australian Bank BSB & Account Number' : 'Pay with VISA, Mastercard or Amex')),
        icon: (react_1.default.createElement(asg_1.Icon, { id: "newIcon", "data-testid": "newIcon", icon: isBankMode ? NewBankIcon_1.NewBankIcon : icons_1.NewCard, css: { margin: 'auto', height: '48px !important', width: '48px !important' } })),
        containerBoxProps: { minWidth: '100% !important', maxWidth: '100% !important' }
    };
    var savedPaymentRadioBtnData = function (data) {
        var accounts = [];
        if (paymentFilter === SavedPaymentTile_types_1.SavedPaymentType.ALL) {
            accounts = data;
        }
        else {
            accounts = data.filter(function (x) { return x.savedPaymentType === paymentFilter; });
        }
        var props = [];
        accounts.forEach(function (payment) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var hasCardExpired = (_a = payment.ccDetails) === null || _a === void 0 ? void 0 : _a.hasExpired;
            var expiry = (hasCardExpired ? 'Expired' : 'Expiry') + " " + ((_c = (_b = payment.ccDetails) === null || _b === void 0 ? void 0 : _b.expiry) === null || _c === void 0 ? void 0 : _c.substring(5, 7)) + " / " + ((_e = (_d = payment.ccDetails) === null || _d === void 0 ? void 0 : _d.expiry) === null || _e === void 0 ? void 0 : _e.substring(0, 4));
            props.push({
                id: payment.savedPaymentId,
                isMuted: hasCardExpired,
                isSelected: hasCardExpired ? false : selectedAccountId === payment.savedPaymentId,
                value: hasCardExpired ? 'undefined' : payment.savedPaymentId,
                descriptionNode: (react_1.default.createElement(asg_1.Text, { size: "14px !important", color: hasCardExpired ? 'red' : asg_1.colors.text.light, style: { color: hasCardExpired ? asg_1.colors['status-error'] : asg_1.colors.text.light }, "data-testid": "tileDescription", lineHeight: "20px" },
                    react_1.default.createElement("span", null, payment.savedPaymentType === SavedPaymentTile_types_1.SavedPaymentType.CARD
                        ? expiry
                        : "BSB " + ((_f = payment.bankDetails) === null || _f === void 0 ? void 0 : _f.bankBSB) + " ACC " + ((_g = payment.bankDetails) === null || _g === void 0 ? void 0 : _g.bankAccountNumber)))),
                onChange: function () {
                    if (hasCardExpired) {
                        return;
                    }
                    else {
                        onChange(payment.savedPaymentId, payment);
                    }
                },
                headerNode: payment.savedPaymentType === SavedPaymentTile_types_1.SavedPaymentType.CARD ? (react_1.default.createElement(SavedPaymentTile_styles_1.MaskedCardNumber, { className: "amex", "data-testid": "maskedCardNumber-" + payment.savedPaymentId },
                    react_1.default.createElement(asg_1.Text, { color: asg_1.colors.text.light, size: "16px !important", "data-testid": "cardNumber-" + payment.savedPaymentId }, (_h = payment.ccDetails) === null || _h === void 0 ? void 0 : _h.number.replace(/\D/g, '')))) : (react_1.default.createElement(asg_1.Text, { color: asg_1.colors.text.light, size: "16px !important", lineHeight: "20px", "data-testid": "bank-" + payment.savedPaymentId }, (_j = payment.bankDetails) === null || _j === void 0 ? void 0 : _j.bank)),
                icon: (react_1.default.createElement(asg_1.Icon, { id: "ccicon", "data-testid": "ccicon", icon: payment.savedPaymentType === SavedPaymentTile_types_1.SavedPaymentType.CARD ? icons_1.CreditCardStandard : icons_1.BankAccount, css: { margin: 'auto', height: '48px !important', width: '48px !important' }, stroke: hasCardExpired ? asg_1.colors.tertiaryText.light : '' })),
                containerBoxProps: { minWidth: '100% !important', maxWidth: '100% !important' }
            });
        });
        return props;
    };
    //Get SavedWallet
    var _c = (0, client_1.useLazyQuery)(SavedPaymentTile_1.GET_SAVED_PAYMENTS_DETAILS, {
        onCompleted: function (response) {
            var _a;
            if (response.savedPayments.payments.length > 0) {
                var radioBtnData = savedPaymentRadioBtnData((_a = response === null || response === void 0 ? void 0 : response.savedPayments) === null || _a === void 0 ? void 0 : _a.payments);
                radioBtnData === null || radioBtnData === void 0 ? void 0 : radioBtnData.push(addNewRadioBtnData);
                setRadioBtnProps((0, tslib_1.__spreadArray)([], radioBtnData, true));
            }
            else {
                onError && onError();
                onChange(exports.ADD_NEW);
            }
            setLoading(false);
        },
        onError: function () {
            setLoading(false);
            onChange(exports.ADD_NEW);
            onError && onError();
        },
        fetchPolicy: 'cache-first'
    }), getSavedBankAccounts = _c[0], savedAccountLoading = _c[1].loading;
    (0, react_1.useEffect)(function () {
        getSavedBankAccounts({
            variables: {
                savedPaymentsInput: {
                    customerNumber: customerNumber,
                    searchFilter: 'ALL'
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        savedAccountLoading && react_1.default.createElement(SavedPaymentTile_loadingState_1.SavedPaymentLoadingState, null),
        !savedAccountLoading && radioBtnProps.length > 0 && (react_1.default.createElement(asg_1.Box, { margin: {
                horizontal: responsiveSize === 'xs' ? 'none' : 'none'
            }, "data-testid": "savedPayment-card" },
            displayHeaderTitle && (react_1.default.createElement(asg_1.Heading, { level: "4", "data-testid": "savedPayment-heading" }, isBankMode ? 'Saved Bank Accounts/My Wallet' : 'Saved Cards/My Wallet')),
            react_1.default.createElement(asg_1.Box, { margin: {
                    vertical: responsiveSize === 'xs' ? 'xsmall' : 'none'
                } },
                react_1.default.createElement(asg_1.FlexGrid, null,
                    react_1.default.createElement(asg_1.FlexGridItem, null,
                        react_1.default.createElement(asg_1.RadioGroup, { name: radioGroupName, id: radioGroupName, value: selectedAccountId }, radioBtnProps.map(function (account) { return (react_1.default.createElement(asg_1.Box, { key: account.id, margin: { top: 'small' } },
                            react_1.default.createElement(myaccount_frontend_shared_1.RadioButtonTile, { key: account.id, id: account.id, isMuted: account.isMuted, isSelected: selectedAccountId === account.value, value: account.value, description: account.description, descriptionNode: account.descriptionNode, onChange: account.onChange, headerNode: account.headerNode, icon: account.icon, containerBoxProps: account.containerBoxProps }))); })))))))));
};
exports.default = SavedPaymentTile;
//# sourceMappingURL=SavedPaymentTile.js.map